// 加载所有类型的消息组件(./Msg*/index.vue)
const req = require.context('./', true, /Msg\w+\/index\.vue/);

const components = req.keys().reduce((components, module) => {
  const comps = { ...components };
  const mod = req(module).default;

  // 从module路径中找出组件名称。 注意，如果导入path发生变化，这里也需要做修改。
  const modNmae = module.replace('./', '').replace('/index.vue', '');
  comps[modNmae] = mod;
  return comps;
}, {});

export default components;
